import type { ReactElement } from "react";

import Accessibility from "@/app/legal/accessibility/page";
import Disclaimer from "@/app/legal/disclaimer/page";
import Privacy from "@/app/legal/privacy/page";
import Security from "@/app/legal/security/page";
import Terms from "@/app/legal/terms/page";
import Home from "@/app/page";

/**
 * React-router route table — the single source of truth for which component
 * serves which URL. `src/seo-routes.ts` carries the same paths with their meta
 * and schema; `vite.config.ts` prerenders both together.
 */
export const routes: { path: string; element: ReactElement }[] = [
  { path: "/", element: <Home /> },
  { path: "/legal/accessibility", element: <Accessibility /> },
  { path: "/legal/disclaimer", element: <Disclaimer /> },
  { path: "/legal/privacy", element: <Privacy /> },
  { path: "/legal/security", element: <Security /> },
  { path: "/legal/terms", element: <Terms /> },
];
